<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">
        {{ $t('school.payment.setup.feeSetup.pageTitle') }}
      </h1>
      <ts-breadcrumb :items="[
        { text: $t('toHomePage'), href: '/' },
        {
          text: $t('school.payment.setup.feeSetup.pageTitle'),
          href: '/fee-setups'
        },
        {
          text: $t('add_new'),
          active: true
        }
      ]" />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="row">
          <div class="col-md-9">
            <form class="form-horizontal">
              <fieldset>
                <legend>
                  {{ $t('school.payment.setup.feeSetup.actionForm') }}
                </legend>
                <div class="row">
                  <div class="col-md-6">
                    <div class="row form-group">
                      <label class="col-md-4 col-form-label required">{{
                        $t('school.payment.setup.feeSetup.feeType')
                      }}</label>
                      <div class="col-md-8">
                        <select class="form-control" :class="{ 'is-invalid': errors.has('fee_type_id') }"
                          v-model.number="model.fee_type_id" @change="switchFeeType">
                          <option value>{{ $t('select') }}</option>
                          <option v-for="(feeType, index) in feeTypes" :key="index" :value="feeType.value">
                            {{ feeType.text }}
                          </option>
                        </select>
                        <div class="invalid-feedback" v-if="errors.has('fee_type_id')">
                          {{ errors.first('fee_type_id') }}
                        </div>
                      </div>
                    </div>
                    <div class="row form-group">
                      <label class="col-md-4 col-form-label">{{
                        $t('school.payment.setup.feeSetup.feeNameKH')
                      }}</label>
                      <div class="col-md-8">
                        <input v-model.trim="model.fee_name_kh" type="text" class="form-control"
                          :class="{ 'is-invalid': errors.has('fee_name_kh') }" />
                        <div class="invalid-feedback" v-if="errors.has('fee_name_kh')">
                          {{ errors.first('fee_name_kh') }}
                        </div>
                      </div>
                    </div>
                    <div class="row form-group">
                      <label class="col-md-4 col-form-label required">{{
                        $t('school.payment.setup.feeSetup.feeNameEN')
                      }}</label>
                      <div class="col-md-8">
                        <input v-model.trim="model.fee_name_en" type="text" class="form-control"
                          :disabled="this.isBusFee" :class="{ 'is-invalid': errors.has('fee_name_en') }" />
                        <div class="invalid-feedback" v-if="errors.has('fee_name_en')">
                          {{ errors.first('fee_name_en') }}
                        </div>
                      </div>
                    </div>
                    <div class="row form-group">
                      <label class="col-md-4 col-form-label required">{{
                        $t('school.payment.setup.feeSetup.amount')
                      }}</label>
                      <div class="col-md-8">
                        <input v-model.number="model.fee_amount" type="number" step="any" class="form-control"
                          :class="{ 'is-invalid': errors.has('fee_amount') }" />
                        <div class="invalid-feedback" v-if="errors.has('fee_amount')">
                          {{ errors.first('fee_amount') }}
                        </div>
                      </div>
                    </div>
                    <div class="row form-group" v-if="isTuitionFee || isStudyMaterialFee">
                      <label class="col-md-4 col-form-label" :class="{
                        required: isTuitionFee || isStudyMaterialFee
                      }">{{
  $t('school.payment.setup.feeSetup.termSemesterOrder')
}}</label>
                      <div class="col-md-8">
                        <input v-model.number="model.term_semester_order" type="number" class="form-control" :class="{
                          'is-invalid': errors.has('term_semester_order')
                        }" />
                        <div class="invalid-feedback" v-if="errors.has('term_semester_order')">
                          {{ errors.first('term_semester_order') }}
                        </div>
                      </div>
                    </div>
                    <div class="row form-group" v-if="isTuitionFee">
                      <label class="col-md-4 col-form-label">{{
                        $t('school.payment.setup.feeSetup.roomType')
                      }}</label>
                      <div class="col-md-8">
                        <select class="form-control" :class="{ 'is-invalid': errors.has('room_type_id') }"
                          v-model.number="model.room_type_id" disabled>
                          <option :value="null">{{ $t('select') }}</option>
                          <option v-for="(roomType, index) in roomTypes" :key="index" :value="roomType.value">
                            {{ roomType.text }}
                          </option>
                        </select>
                        <div class="invalid-feedback" v-if="errors.has('room_type_id')">
                          {{ errors.first('room_type_id') }}
                        </div>
                      </div>
                    </div>
                    <div class="row form-group" v-if="isStudyMaterialFee">
                      <label class="col-md-4 col-form-label"></label>
                      <div class="col-md-8">
                        <ts-checkbox v-model="model.no_stock">{{
                          $t('school.payment.setup.feeSetup.noStock')
                        }}</ts-checkbox>
                      </div>
                    </div>
                    <div class="row form-group" v-if="isServiceFee">
                      <label class="col-md-4 col-form-label"></label>
                      <div class="col-md-8">
                        <ts-checkbox v-model="model.is_onetime_service">{{
                          $t('school.payment.setup.feeSetup.oneTimeService')
                        }}</ts-checkbox>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="text-center" v-if="isOtherFee ||
                        isOtherMaterialFee ||
                        model.fee_type_id == ''
                        ">
                      <h4 class="ts-text-gray-400">
                        {{
                          $t(
                            'school.payment.setup.feeSetup.the_panel_will_appear_base_on_fee_type'
                          )
                        }}
                      </h4>
                    </div>
                    <academic v-model="model" :validate="errors"
                      v-if="isTuitionFee || isServiceFee || isStudyMaterialFee" />
                    <transportation v-model="model" :validate="errors" v-if="isBusFee" />
                  </div>
                </div>
              </fieldset>
            </form>
          </div>
          <div class="col-md-3">
            <form class="form-horizontal">
              <fieldset>
                <legend>
                  {{ $t('school.payment.setup.feeSetup.applyToBranch') }}
                </legend>
                <branch-list v-model="model" />
              </fieldset>
            </form>
          </div>
        </div>
        <br />
        <div class="row">
          <div class="col-md-12 form-group">
            <form>
              <fieldset>
                <legend>{{ $t('school.payment.setup.feeSetup.item') }}</legend>
                <div class="text-center" v-if="model.fee_type_id == '' ||
                  isTuitionFee ||
                  isBusFee ||
                  isServiceFee ||
                  isOtherFee
                  ">
                  <h4 class="ts-text-gray-400">
                    {{
                      $t(
                        'school.payment.setup.feeSetup.the_panel_will_appear_base_on_fee_type'
                      )
                    }}
                  </h4>
                </div>
                <sub-items v-model="model" :validate="errors" v-if="isStudyMaterialFee || isOtherMaterialFee" />
                <div class="validate" v-if="errors.has('sub_item_list')">
                  {{ errors.first('sub_item_list') }}
                </div>
              </fieldset>
            </form>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 text-right">
            <ts-button color="info" outline class="btn btn-default mr-2" @click="$router.push({ name: 'fee-setup' })">{{
              $t('cancel') }}</ts-button>
            <ts-button outline color="primary" class="mr-2" @click.prevent="saveAddNew" :waiting="waiting_save_add_new">{{
              $t('save_add_new') }}</ts-button>
            <ts-button :waiting="waiting" class="btn btn-primary" @click.prevent="save">{{ $t('save') }}</ts-button>
          </div>
        </div>
      </ts-card-wrapper>
    </ts-card>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { Errors } from 'form-backend-validation'
import Academic from './academic'
import Transportation from './transportation'
import BranchList from './branch-list'
import SubItems from './sub-items'

export default {
  name: 'feeSetupCreate',
  components: {
    Academic,
    Transportation,
    BranchList,
    SubItems
  },
  data() {
    return {
      model: {
        fee_type_id: '',
        branch_id_list: [],
        fee_name_kh: '',
        fee_name_en: '',
        acp_id: '',
        acps_id: '',
        level_id: '',
        grade_id: '',
        term_semester_order: '',
        payment_term_id: '',
        distance_id: '',
        way_id: '',
        shift_id: 5,
        fee_amount: '',
        inventory_code: null,
        debit_account_id: '',
        credit_account_id: '',
        sub_item_list: [],
        new_old_status_id: 0,
        is_onetime_service: false,
        room_type_id: 1,
        no_stock: false
      },
      errors: new Errors(),
      waiting_save_add_new: false,
      waiting: false
    }
  },
  created() {
    this.$store.commit('feeSetup/SET_BRANCH', [])
  },
  computed: {
    ...mapState('feeSetup', ['feeTypes', 'roomTypes', 'paymentTerm', 'distances', 'transactions']),
    isTuitionFee() {
      return this.model.fee_type_id == 1
    },
    isServiceFee() {
      return this.model.fee_type_id == 2
    },
    isBusFee() {
      return this.model.fee_type_id == 3
    },
    isStudyMaterialFee() {
      return this.model.fee_type_id == 4
    },
    isOtherMaterialFee() {
      return this.model.fee_type_id == 5
    },
    isOtherFee() {
      return this.model.fee_type_id == 6
    },
    feeNameEn() {
      if (this.model.fee_type_id !== 3) return this.model.fee_name_en;

      const distance = this.distances.filter(el => el.distance_id == this.model.distance_id).map(el => el.distance_description);
      const way = this.transactions.filter(el => el.way_id == this.model.way_id).map(el => el.way_description);
      const paymentTerm = this.paymentTerm.filter(el => el.payment_term_id == this.model.payment_term_id).map(el => el.payment_term);

      return `Bus Fee_${distance}_${way}_${paymentTerm}`;
    }
  },
  methods: {
    saveAddNew() {
      this.waiting_save_add_new = true
      this.errors = new Errors()
      this.$store
        .dispatch('feeSetup/store', this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.clearInputAddNew()
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting_save_add_new = false
        })
    },
    save() {
      this.waiting = true
      this.errors = new Errors()
      this.$store
        .dispatch('feeSetup/store', this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.clearInput()
          this.$router.push({ name: 'fee-setup' })
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    clearInput() {
      this.model = {
        fee_type_id: '',
        branch_id_list: [],
        fee_name_kh: '',
        fee_name_en: '',
        acp_id: '',
        acps_id: '',
        level_id: '',
        grade_id: '',
        term_semester_order: '',
        payment_term_id: '',
        distance_id: '',
        way_id: '',
        shift_id: 5,
        fee_amount: '',
        inventory_code: '',
        debit_account_id: '',
        credit_account_id: '',
        sub_item_list: [],
        new_old_status_id: 0,
        is_onetime_service: false,
        no_stock: false
      }
    },
    clearInputAddNew() {
      this.model.fee_name_kh = '',
        this.model.fee_name_en = '',
        this.model.level_id = '',
        this.model.grade_id = '',
        this.model.term_semester_order = '',
        this.model.payment_term_id = '',
        this.model.distance_id = '',
        this.model.way_id = '',
        this.model.shift_id = 5,
        this.model.fee_amount = '',
        this.model.inventory_code = '',
        this.model.debit_account_id = '',
        this.model.credit_account_id = '',
        this.model.sub_item_list = [],
        this.model.new_old_status_id = 0,
        this.model.is_onetime_service = false,
        this.model.no_stock = false
    },
    switchFeeType() {
      ; (this.model.branch_id_list = []),
        (this.model.fee_name_kh = ''),
        (this.model.fee_name_en = ''),
        (this.model.acp_id = ''),
        (this.model.acps_id = ''),
        (this.model.level_id = ''),
        (this.model.grade_id = ''),
        (this.model.term_semester_order = ''),
        (this.model.payment_term_id = ''),
        (this.model.distance_id = ''),
        (this.model.way_id = ''),
        (this.model.shift_id = 5),
        (this.model.fee_amount = ''),
        (this.model.inventory_code = ''),
        (this.model.debit_account_id = ''),
        (this.model.credit_account_id = ''),
        (this.model.sub_item_list = []),
        (this.model.new_old_status_id = 0),
        (this.model.is_onetime_service = false),
        (this.model.no_stock = false)
    }
  },
  watch: {
    feeNameEn(newVal) {
      this.model.fee_name_en = newVal;
    }
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('feeSetup/RESET_STATE')
    next()
  }
}
</script>
